import request from '@/utils/request';export const listAdminScopes=()=>request({url:'/dkmall/admin-scope',method:'get'});export const saveAdminScope=params=>request({url:'/dkmall/admin-scope',method:'put',params})
